<script>
import Segment from '@/Segment';
import Affiliates from '@/mixins/Affiliates';

export default {
  name: 'TrackedPage',
  mixins: [Affiliates],
  data() {
    return {
      shownAt: null,
    };
  },
  mounted() {
    this.shownAt = +new Date();
    this.$nextTick(() => {
      Segment.trackUserInteraction(`Saving_${this.$options.name}Entered`, { affiliate: this.affiliateId });
    });
  },
  destroyed() {
    const destroyedAt = +new Date();
    Segment.trackUserInteraction(`Saving_${this.$options.name}TimeSpent`, { timeSpent: destroyedAt - this.shownAt });
  },
};
</script>
